import { HttpServiceResponse } from '../../shared'
import AbstractProvider from '../../shared/abstract.provider'
import { AccEntryCommentsTypes, AccEntryViewTypes } from '../models/accEntry.types'

export class AccEntryCommentsProvider extends AbstractProvider {
  urlPath = 'acc_entry_comments_api'

  public comment<T>(action: AccEntryCommentsTypes, params: Record<string, any>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
      ...params,
    })

    return this.http.get(`${this.url}?${query}`)
  }
}
